// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3TKRj","info":"PatientInfo_info__DQbwt"};